"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Touchable = exports.List = exports.Item = exports.DropdownBox = void 0;

var _elements = require("@superlogica/foundation/elements");

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var DropdownBox = _styledComponents.default.div.withConfig({
  componentId: "sc-16dom3k-0"
})(["", ""], function (_ref) {
  var show = _ref.show,
      height = _ref.height,
      direction = _ref.direction;
  return "\n    display: block;\n    position: absolute;\n    margin: 0px;\n    z-index:999;\n    min-width: 250px;\n    background-color: ".concat(_tokens.colors.neutral0, ";\n    border-radius: ").concat(_tokens.borderRadius.xs, "px;\n    border: ").concat(_tokens.borderWidth.xs, "px solid ").concat(_tokens.colors.neutral200, ";\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);\n    ").concat(direction, "\n  ");
});

exports.DropdownBox = DropdownBox;

var Item = _styledComponents.default.li.withConfig({
  componentId: "sc-16dom3k-1"
})([""]);

exports.Item = Item;

var List = _styledComponents.default.ul.withConfig({
  componentId: "sc-16dom3k-2"
})(["z-index:1000;min-width:10rem;padding-top:", "px;padding-bottom:", "px;background:", ";& a.dropdown-item,& button.dropdown-item{display:flex;align-items:center;width:100%;padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;clear:both;transition:0.2s all linear;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0;font-weight:", ";color:", ";", " &:hover{background:", ";}&:focusin{background:", ";}& svg{width:16px;}}& div.dropdown-item{& button{display:flex;align-items:center;width:100%;padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;clear:both;transition:0.2s all linear;color:#212529;text-align:inherit;text-decoration:none;white-space:nowrap;background-color:transparent;border:0;font-weight:", ";color:", ";", " &:hover{background:", ";}&:focusin{background:", ";}& svg{width:16px;}}}"], _tokens.spacing.vertical.xxs, _tokens.spacing.vertical.xxs, _tokens.colors.ghost, _elements.boxPadding.squish.sm.top, _elements.boxPadding.squish.sm.right, _elements.boxPadding.squish.sm.bottom, _elements.boxPadding.squish.sm.left, _tokens.fontWeight.normal, _tokens.colors.neutral950, function (_ref2) {
  var theme = _ref2.theme;
  return "\n      font-family: ".concat(theme.fonts.default, ", sans-serif;\n      font-size: ").concat(theme.typography.body02.desktop.fontSize, "px;\n      line-height: ").concat(theme.typography.body02.desktop.lineHeight, "px;\n      letter-spacing: ").concat(theme.typography.body02.desktop.letterSpacing, "px;\n    ");
}, _tokens.colors.neutral50, _tokens.colors.neutral50, _elements.boxPadding.squish.sm.top, _elements.boxPadding.squish.sm.right, _elements.boxPadding.squish.sm.bottom, _elements.boxPadding.squish.sm.left, _tokens.fontWeight.normal, _tokens.colors.neutral950, function (_ref3) {
  var theme = _ref3.theme;
  return "\n        font-family: ".concat(theme.fonts.default, ", sans-serif;\n        font-size: ").concat(theme.typography.body02.desktop.fontSize, "px;\n        line-height: ").concat(theme.typography.body02.desktop.lineHeight, "px;\n        letter-spacing: ").concat(theme.typography.body02.desktop.letterSpacing, "px;\n      ");
}, _tokens.colors.neutral50, _tokens.colors.neutral50);

exports.List = List;

var Touchable = _styledComponents.default.div.withConfig({
  componentId: "sc-16dom3k-3"
})(["", " display:inline-block;white-space:nowrap;"], function (_ref4) {
  var fluid = _ref4.fluid;
  return fluid && "width:100%;";
});

exports.Touchable = Touchable;

var Wrapper = _styledComponents.default.div.withConfig({
  componentId: "sc-16dom3k-4"
})(["position:relative;& *,&::after,&::before{box-sizing:border-box;}"]);

exports.Wrapper = Wrapper;